
import Button from '../base/Button';

export default function Footer() {
  const socialLinks = [
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-facebook-line', href: '#', label: 'Facebook' },
    { icon: 'ri-twitter-x-line', href: '#', label: 'Twitter' },
    { icon: 'ri-tiktok-line', href: '#', label: 'TikTok' }
  ];

  const quickLinks = [
    { label: 'Tentang M4CR', href: '/tentang' },
    { label: 'Program Kami', href: '/program' },
    { label: 'Lokus Proyek', href: '/lokus' },
    { label: 'FAQ', href: '/faq' }
  ];

  const resourceLinks = [
    { label: 'Siaran Pers', href: '/siaran-pers' },
    { label: 'Artikel', href: '/artikel' },
    { label: 'Laporan Tahunan', href: '/laporan' },
    { label: 'Kontak', href: '/kontak' }
  ];

  return (
    <footer className="bg-[#2D8B57] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <div className="text-3xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
                M4CR
              </div>
              <p className="text-white/90 leading-relaxed mb-8">
                Membangun ketahanan pesisir Indonesia melalui rehabilitasi mangrove dan pemberdayaan masyarakat lokal untuk masa depan yang berkelanjutan.
              </p>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-200"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold mb-6">Navigasi</h3>
              <ul className="space-y-4">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/90 hover:text-white transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h3 className="text-xl font-bold mb-6">Sumber Daya</h3>
              <ul className="space-y-4">
                {resourceLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/90 hover:text-white transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h3 className="text-xl font-bold mb-6">Newsletter</h3>
              <p className="text-white/90 mb-6">
                Dapatkan update terbaru tentang program dan dampak M4CR
              </p>
              
              <form className="space-y-4">
                <div>
                  <input
                    type="email"
                    placeholder="Email Anda"
                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
                  />
                </div>
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="newsletter-consent"
                    className="mt-1 w-4 h-4 text-[#2D8B57] bg-white/10 border-white/20 rounded focus:ring-white/50"
                  />
                  <label htmlFor="newsletter-consent" className="text-sm text-white/90">
                    Saya setuju menerima newsletter dan update dari M4CR
                  </label>
                </div>
                <Button 
                  variant="outline" 
                  className="w-full border-white text-white hover:bg-white hover:text-[#2D8B57]"
                >
                  Berlangganan
                </Button>
              </form>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-white/90 text-sm">
              © 2024 M4CR. Hak cipta dilindungi undang-undang.
            </div>
            
            <div className="flex items-center space-x-6 text-sm">
              <a href="/privasi" className="text-white/90 hover:text-white transition-colors duration-200">
                Kebijakan Privasi
              </a>
              <a href="/aksesibilitas" className="text-white/90 hover:text-white transition-colors duration-200">
                Aksesibilitas
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-white/90 hover:text-white transition-colors duration-200"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
